<template>
  <!-- 结算数据 -->
  <div>
    <HeadControl ref="headControl" :titleName="'结算数据'" :showorg="false" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker" />
    <div class="wrap">
      <div class="top">
        <div class="top_left">
          <div class="image">
            <img :src="iconAndImg.itemIcon" />
          </div>
          <div class="title">
            <div class="total">结算项目总数</div>
            <div class="number"><span class="num">{{iconAndImg.count}}</span>个</div>
          </div>
        </div>
        <div class="top_right" ref="settlementNum"></div>
      </div>
      <div class="bottom">
        <div class="left">
          <div class="projectType" ref="projectType"></div>
          <div class="nodata_box" v-if="!projectTypeChartShow">
              <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
              <span>暂无数据</span>
          </div>
        </div>
        <div class="right">
          <div class="cooperationType" ref="cooperationType"></div>
          <div class="nodata_box" v-if="!cooperationChartShow">
            <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
            <span>暂无数据</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Urls from "@/helper/Urls";
import HeadControl from "@/components/HeadControl";
export default {
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], // 时间
      settlementData: {}, //结算项目数据
      iconAndImg: {},
      projectTypeData: [],   //项目类型数据
      screenWidth: document.body.clientWidth,
      cooperationTypeData: [],  //合作类型数据
      isH5: false
    };
  },
  components: {
    HeadControl,
  },
  methods: {
    init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    changeVal(val) {
      this.orgCode = val
      this.getSettlementProjectData()
      this.getSettlementProjectTypeData()
      this.getCooperationTypeData()
    },
    changDate(val) {
      this.dataRange = val
      this.getSettlementProjectData()
      this.getSettlementProjectTypeData()
      this.getCooperationTypeData()
    },
    changePicker(val) {
      this.dataRange = val
      this.getSettlementProjectData()
      this.getSettlementProjectTypeData()
      this.getCooperationTypeData()
    },
    getSettlementProjectData() {
      let url = Urls.getEchartsSettlementReportDataByProject;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.settlementData = server_data.data;
      });
    },
    getSettlementProjectTypeData() {
      let url = Urls.getEchartsSettlementReportDataByType;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'PROJECT_CATEGORY'
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.projectTypeData = server_data.data;
      });
    },
    getCooperationTypeData() {
      let url = Urls.getEchartsSettlementReportDataByCooperationType;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: 'COOPERATION_TYPE'
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.cooperationTypeData = server_data.data;
      });
    },
    initSettlementNumChart() {
      this.settlementNumChart = this.$echarts.init(this.$refs.settlementNum, {width: 'auto'});
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        grid: {
          left: this.isH5 ? 20 : 60,
          top: 32,
          right: this.isH5 ? 20: 60,
          bottom: 30,
        },
        tooltip:{
          trigger: 'item',
          formatter:(params) => {
            return `<div style="font-size:14px; padding:4px;">
                         <div>${params.name}：${this.settlementData.series[0].data[params.dataIndex]}个</div>
                         <div>占比：${params.value}%</div>
                     </div>`
          }
        },
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              formatter: (val, index) => {
                let res = "";
                this.settlementData.series[0].data.forEach((item, i) => {
                  if (i == index) {
                    res = item;
                  }
                });
                return val + `（${res}个）`;
              },
              textStyle: {
                color: "#666666",
                fontSize: "14",
                lineHeight: 20,
              },
              padding: [0, -110, 35, 15],
              align: "left",
              rich: {}
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: this.settlementData.yAxis.data,
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            position: "left",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#57b9ff",
                fontSize: "14",
              },
              padding: [0, -45, -45, 15],
              formatter: "({value}%)",
              align: "left",
              rich: {}
            },
            data: this.settlementData.series[0].percent,
          },
        ],
        series: [
          {
            type: "bar",
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: "#57b9ff",
              },
            },
            barWidth: 10,
            data: this.settlementData.series[0].percent,
          },
          {
            type: "bar",
            silent: true,
            barWidth: 10,
            barGap: "-100%",
            data: [100, 100],
            itemStyle: {
              normal: {
                color: "#eeeeee",
                barBorderRadius: 10,
              },
            },
          },
        ],
      };
      this.settlementNumChart.setOption(option);
      //pc端自适应页面大小
      window.addEventListener("resize", () => {
        this.isH5? this.settlementNumChart.resize({width: this.screenWidth - 24}) : this.settlementNumChart.resize();
      });
      this.isH5 ? this.settlementNumChart.resize({width: this.screenWidth - 24}) : this.settlementNumChart.resize();
    },
    initProjectTypeChart() {
      this.projectTypeChart = this.$echarts.init(this.$refs.projectType);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "项目类型",
          padding: this.isH5 ? [24,0,0,15] : [24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show:this.isH5 ? true : (this.screenWidth <=1366 ? true : false) , 
          trigger: 'item',      
          formatter:params=>{
             return `<div style="font-size:14px; padding:4px;">
                         <div>${params.name}：${params.value}个</div>
                         <div>占比：${params.data.percent}%</div>
                     </div>`
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.isH5 ? "horizontal" : "vertical",
          x: this.isH5 ?  '120':'30',
          y: this.isH5 ? '20' : '70',
          itemGap: 14,
          itemWidth: 10,
          itemHeight: 10,
          data: this.projectTypeData,
          formatter: (name) => {
            return name;
          },
        },
        series: [
          {
            name: "项目类型",
            type: "pie",
            stillShowZeroSum:false,
            radius: ['40%','60%'],
            center: ["50%", "50%"],
            silent:this.isH5 ? false : (this.screenWidth <= 1366 ? false : true) , // 鼠标悬浮高亮
            // avoidLabelOverlap: true,
            // startAngle:270, //起始角度
            itemStyle: {
              align: "left",
              normal: {
                borderWidthLeft:this.isH5 ? 'none' : (this.screenWidth <=1366 ? 'none' : 1) ,
                borderColor:this.isH5 ? 'none' : (this.screenWidth <=1366 ? 'none' : '#fff') ,
                label: {
                  show: this.projectTypeChartShow ? true : false,
                  position:this.isH5 ? 'inside' : (this.screenWidth <=1366 ? 'inside' : 'outside') ,
                  fontSize:12,
                  formatter: (params) => {
                    if(this.isH5 || this.screenWidth <= 1366){
                      return params.value == 0 ? '' : `${params.data.percent}%`
                    } else {
                      return `{left|${params.name}：${params.value}个\n占比：${params.data.percent}%}`;
                    }
                  },
                  rich: {
                    left: {
                      align: "left",
                      lineHeight: 15,
                      color: "#666666",
                    },
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show:this.projectTypeChartShow ? true : false,
                length:  15,
                length2: this.isH5 ? 15 : 20,
              },
            },
            data: this.projectTypeData,
          },
        ],
      };
      this.projectTypeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.projectTypeChart.resize({width: this.screenWidth - 24}) : this.projectTypeChart.resize();
      });
      this.isH5 ? this.projectTypeChart.resize({width: this.screenWidth - 24}) : this.projectTypeChart.resize();
    },
    initCooperationTypeChart() {
      this.cooperationTypeChart = this.$echarts.init(this.$refs.cooperationType);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "合作类型",
          padding: this.isH5 ? [24,0,0,15]:[24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show:this.isH5 ? true : (this.screenWidth <=1366 ? true : false) , 
          trigger: 'item',      
          formatter:params=>{
             return `<div style="font-size:14px; padding:4px;">
                         <div>${params.name}：${params.value}个</div>
                         <div>占比：${params.data.percent}%</div>
                     </div>`
          }
        },
        color: ["#59b9fe", "#62d8ae", "#ffb971"],
        legend: {
          orient: this.isH5 ? "horizontal" : "vertical",
          x: this.isH5 ?  '120':'30',
          y: this.isH5 ? '20' : '70',
          itemGap: 14,
          itemWidth: 10,
          itemHeight: 10,
          data: this.cooperationTypeData,
          formatter: (name) => {
            return name;
          },
        },
        series: [
          {
            name: "合作类型",
            type: "pie",
            stillShowZeroSum:false,
            radius: ["0%", "60%"],
            center: ["50%", "50%"],
            silent:this.isH5 ? false : (this.screenWidth <= 1366 ? false : true) , // 鼠标悬浮高亮
            // avoidLabelOverlap: true,
            // startAngle:this.isH5 ? 90 : 270, //起始角度
            itemStyle: {
              align: "left",
              normal: {
                borderWidthLeft:this.isH5 ? 'none' : (this.screenWidth <=1366 ? 'none' : 1) ,
                borderColor:this.isH5 ? 'none' : (this.screenWidth <=1366 ? 'none' : '#fff') ,
                label: {
                  show: this.cooperationChartShow ? true : false,
                  position:this.isH5 ? 'inside' : (this.screenWidth <=1366 ? 'inside' : 'outside') ,
                  fontSize:12,
                  formatter: (params) => {
                    if(this.isH5 || this.screenWidth <= 1366){
                      return params.value == 0 ? '' : `${params.data.percent}%`
                    } else {
                      return `{left|${params.name}：${params.value}个\n占比：${params.data.percent}%}`;
                    }
                  },
                  rich: {
                    left: {
                      align: "left",
                      lineHeight: this.isH5 ? 12:18,
                      color: "#666666",
                    },
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show:this.cooperationChartShow ? true : false,
                length:  15,
                length2: this.isH5 ? 15 : 20,
              },
            },
            data: this.cooperationTypeData,
          },
        ],
      };
      this.cooperationTypeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.cooperationTypeChart.resize({width: this.screenWidth - 24}) : this.cooperationTypeChart.resize();
      });
      this.isH5 ? this.cooperationTypeChart.resize({width: this.screenWidth - 24}) : this.cooperationTypeChart.resize();
    }
  },
  watch: {
    settlementData(newVal) {
      if (newVal) {
        this.iconAndImg = newVal.report
        this.initSettlementNumChart();
        this.settlementNumChart.resize()
      }
    },
    projectTypeData(newVal) {
      if(newVal) {
        this.initProjectTypeChart()
      }
    },
    cooperationTypeData(newVal) {
      if(newVal) { 
        this.initCooperationTypeChart()
      }
    },
    screenWidth() {
      if(this.cooperationChartShow) {
        this.initCooperationTypeChart()
      }
      if(this.projectTypeChartShow) {
        this.initProjectTypeChart()
      }
    }
  },
  computed: {
    projectTypeChartShow(){
      return this.projectTypeData.some(item => item.value > 0)
    },
    cooperationChartShow() {
      return this.cooperationTypeData.some(item => item.value > 0)
    }
  },
  mounted() {
    if(this.$route.query.identification) {
      this.isH5 = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 0.29rem;
  .top {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 24px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.1rem;
    .top_left {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22%;
      border-right: 1px solid #ddd;
      .image {
        width: 75px;
        height: 75px;
        margin-right: 10%;
      }
      .title {
        width: 85px;
        height: 75px;
        line-height: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-bottom: none;
        .total {
          font-size: 14px;
          color: #666;
          margin-bottom: 12px;
        }
        .number {
          color: #333;
          .num {
            font-size: 26px;
          }
        }
      }
    }
    .top_right {
      width: 78%;
      height: 200px;
    }
  }
  .bottom {
    display: flex;
    .left, .right{
      width: 50%;
      position: relative;
      .nodata_box{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
        span{
          font-size: 16px;
          color: #ccc;
          line-height: 44px;
        }
      }
    }
    .left {
      margin-right: 24px;
    }
    .projectType,
    .cooperationType {
      width: 100%;
      height: 390px;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      .top_box{
        display: flex;
        .box_title{
          font-size: 18px;
          font-weight: bold;
          padding: 24px 30px;
        }
        .legendList{
          width: calc(100% - 350px);
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: #666;
          font-size: 12px;
          li{
            display: flex;
            align-items: center;
          }
          li::before{
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 10px;
            background-color: yellow;
          }
          li:first-child::before{
            background-color: #57B9FF;
          }
          li:nth-child(2)::before{
            background-color: #61D9AC;
          }
          li:last-child::before{
            background-color: #FFB96E;
          }
        }
      }
    }
    
  }
}
@media screen and (max-width: 768px) {
  .wrap{
    width: calc(100% - 0.24rem);
    margin: 0 auto;
    margin-top: -0.05rem;
    .top{
      flex-direction: column;
      border: none;
      margin-bottom: 0.12rem;
      .top_left{
        width: calc(100% - 0.34rem);
        padding: 0.2rem 0;
        justify-content: space-around;
        border-right: none;
        border-bottom: 1px solid #ddd;
      }
      .top_right{
        width: 100%;
      }
    }
    .bottom{
      flex-direction: column;
      .left, .right{
        width: 100%;
      }
      .projectType, .cooperationType{
        border: none;
        background-color: #fff !important;
        .top_box{
          .legendList{
            width: auto;
            li{
              margin-right: 15px;
            }
          }
        }
      }
      .projectType{
        margin-bottom: 0.12rem;
        margin-right: 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// closeAccountsData.vue?bbbe2daa